import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const AnalyticsLegendIcon = ({ fill, ...props }: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 10 11">
      <circle cx="5" cy="5.91748" r="5" style={{ fill: fill as string }} />
    </SvgIcon>
  );
};
